import React from "react";
import { NavLink, Outlet, useParams } from "react-router-dom";

import "./EventInvoicesLayout.css";

/**
 * Invoice tab shell.
 *
 * Sprint 14 splits the single invoice screen into "Generate Tax Invoice" and
 * "Manage Invoices". Nested routes rather than local state so each sub-tab is
 * linkable and survives a refresh.
 */
const EventInvoicesLayout: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();

  const tabClass = ({ isActive }: { isActive: boolean }) =>
    `event-invoices-subtab${isActive ? " is-active" : ""}`;

  if (!eventId) return <Outlet />;

  return (
    <div className="event-invoices-layout">
      <nav className="event-invoices-subtabs" aria-label="Invoice sections">
        <NavLink to={`/events/${eventId}/invoices/generate`} className={tabClass}>
          Generate Tax Invoice
        </NavLink>
        <NavLink to={`/events/${eventId}/invoices/manage`} className={tabClass}>
          Manage Invoices
        </NavLink>
      </nav>
      <Outlet />
    </div>
  );
};

export default EventInvoicesLayout;
